<template>
  <div class="about">
    <LevalMenu :LevalMenu="LevalMenu" :indexShow = 'IntroductData'></LevalMenu>
    <Introduct/>
    <Speed/>
    <Target/>
    <History/>
  </div>
</template>

<script>
import LevalMenu from '@/components/common/Posite.vue'
import Introduct from '@/components/about/Introduct.vue'
import Speed from '@/components/about/Speed.vue'
import Target from '@/components/about/Target.vue'
import History from '@/components/about/History.vue'
export default {
  metaInfo () {
    return {
      title: this.title,
      meta: [{
        name: 'keyWords',
        content: this.keyWords
      },
      {
        name: 'description',
        content: this.description
      }]
    }
  },
  data () {
    return {
      LevalMenu: {},
      IntroductData: {},
      id: '',
      title: '',
      keyWords: '',
      description: ''
    }
  },
  methods: {
    async getMenu () {
      this.id = this.$route.query.id
      var target = `#${this.id}`
      const { data: res } = await this.$http.get('/fdata/category?catid=83,92,97,103,104,107,110')
      const { data: res1 } = await this.$http.get('/fdata/category?catid=84')
      const routerName = this.$route.path
      if (res.code === 1) {
        res.data.forEach(item => {
          if (item.biaoshi == routerName) {
            this.LevalMenu = item
          }
        })
        this.title = res1.data[0].seotitle
        this.keyWords = res1.data[0].seokeywords
        this.description = res1.data[0].seodescription
        console.log(this.keyWords)
      }
      console.log(target)
      if(target != "#undefined"){
        setTimeout(() => {
        document.querySelector(target).scrollIntoView({
            behavior: 'smooth'
          })
        }, 300)
      }
      
    }
  },
  components: {
    LevalMenu,
    Introduct,
    Speed,
    Target,
    History
  },
  mounted () {
    this.getMenu()
  }
}
</script>

<style>

</style>
